import {ColumnMain} from "#/models/column-main";
import {Column} from "#/models/column";
import {Trans} from "@lingui/macro";
import React from "react";

const SupplierModel = (): ColumnMain => {
    const columns: Array<Column> = [];
    columns.push({ key: 'id', width: 80, sorter: true, title: <Trans>ID</Trans> });
    columns.push({ key: 'name', filter: true, sorter: true, width: 200, title: <Trans>Name</Trans> });
    columns.push({ key: 'remark', filter: true, sorter: true, width: 250, title: <Trans>Remark</Trans> });
    columns.push({ key: 'updatedDate', width: 150, dateFilter: true, sorter: true, title: <Trans>Updated Date</Trans> });
    columns.push({ key: 'updatedBy', width: 140, sorter: true, title: <Trans>Updated By</Trans> });
    columns.push({ key: 'createdDate', width: 150, dateFilter: true, sorter: true, title: <Trans>Created Date</Trans>, direction: 'desc' });
    columns.push({ key: 'createdBy', width: 140, sorter: true, title: <Trans>Created By</Trans> });

    return {
        columns,
        url: "/resource/suppliers"
    };
};

export default SupplierModel();
